/**
 * history
 * */

import * as History from 'history';

let history = History.createHashHistory();

export default history;
